import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";

export default (editor: Editor, opts: RequiredPluginOptions) => {
  const { block, label, id } = opts;

  if (block) {
    editor.Blocks.add("add-to-cart", {
      media: `
<svg width="44" height="44" class="mx-auto" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.87805 2.9729H4.52162C4.98911 2.9729 5.39421 3.29679 5.4971 3.75282L6.79675 9.51344M6.79675 9.51344L11.5395 30.5353C11.6424 30.9913 12.0475 31.3152 12.515 31.3152H36.4932C36.9607 31.3152 37.3658 30.9913 37.4686 30.5353L41.9361 10.7335C42.0772 10.1082 41.6017 9.51344 40.9606 9.51344H6.79675Z" stroke="#4E4E4E" stroke-width="2.95135" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.5933 42C18.2887 42 19.6631 40.6569 19.6631 39C19.6631 37.3431 18.2887 36 16.5933 36C14.898 36 13.5236 37.3431 13.5236 39C13.5236 40.6569 14.898 42 16.5933 42Z" stroke="#4E4E4E" stroke-width="2.95135" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M30.9189 42C32.6143 42 33.9887 40.6569 33.9887 39C33.9887 37.3431 32.6143 36 30.9189 36C29.2235 36 27.8492 37.3431 27.8492 39C27.8492 40.6569 29.2235 42 30.9189 42Z" stroke="#4E4E4E" stroke-width="2.95135" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.1747 19H27.3375M23.7561 22.5V15.5" stroke="#4E4E4E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
      label,
      category: "Pages",
      select: true,
      content: { type: "add-to-cart" },
      ...block,
    });
  }
};
